var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoContiene({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_473_5999)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 44C34.1503 44 44 34.1503 44 22C44 9.84974 34.1503 0 22 0C9.84974 0 0 9.84974 0 22C0 34.1503 9.84974 44 22 44Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9718 25.3223H17.9923C17.0628 25.3223 16.5981 25.3223 16.2315 25.1618C15.7427 24.9479 15.3543 24.5376 15.1518 24.0212C15 23.6338 15 23.1428 15 22.1608C15 21.1787 15 20.6877 15.1518 20.3003C15.3543 19.7839 15.7427 19.3736 16.2315 19.1596C16.5981 18.9992 17.0628 18.9992 17.9923 18.9992H17.9923H25.9718H25.9718C26.9013 18.9992 27.366 18.9992 27.7327 19.1596C28.2214 19.3736 28.6098 19.7839 28.8123 20.3003C28.9641 20.6877 28.9641 21.1787 28.9641 22.1608C28.9641 23.1428 28.9641 23.6338 28.8123 24.0212C28.6098 24.5376 28.2214 24.9479 27.7327 25.1618C27.366 25.3223 26.9013 25.3223 25.9718 25.3223Z",
    stroke: "#666666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2 2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_473_5999"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoContiene);
export default __webpack_public_path__ + "static/media/NoContiene.b43459bbe4002ee8f6033b35d8322fc9.svg";
export { ForwardRef as ReactComponent };